export const LIVE_VIDEO_ENABLED = 'live_video_enabled';
